if (!customElements.get("tooltip-component")) {
    class toolTip extends HTMLElement {
        constructor() {
            super();
            this.is_open = false;
            console.log("init tooltip");
            this.resizeTimeout = null; // Variable für den Debounce-Timer
        }

        connectedCallback() {
            this.init();
        }

        init() {
            this.button = this.querySelector(".tooltip-label");
            this.text = this.querySelector(".tooltip-text");
            this.addEventListener("mouseenter", this.open.bind(this));
            this.addEventListener("mouseleave", this.close.bind(this));
            window.addEventListener("resize", this.handleResize.bind(this));

            // Setze die Breite initial
            this.setWidth()
        }

        open() {
            if(this.left == 0) this.setWidth()
            this.setAttribute("open", "");
            this.is_open = true;
        }

        close() {
            this.removeAttribute("open");
            this.is_open = false;
        }

        handleResize() {
            // Lösche den vorherigen Timer, falls vorhanden
            clearTimeout(this.resizeTimeout);

            // Setze einen neuen Timer
            this.resizeTimeout = setTimeout(() => {
                this.close()
                this.setWidth();
            }, 200); // Wartezeit in Millisekunden (hier 200ms)
        }

        setWidth() {
            
            const rect = this.getBoundingClientRect();
            const windowWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth; // Verwende die tatsächliche visuelle Breite
            console.log(windowWidth, rect.left)
            // Berechne die Breite zwischen der linken Kante des Elements und der rechten Kante des Fensters
            const tooltipWidth = windowWidth - rect.left - 20;
            this.left = rect.left
        
            // Setze die --width CSS-Variable mit der berechneten Breite
            this.style.setProperty('--width', `${tooltipWidth}px`);
        }
    }

    customElements.define("tooltip-component", toolTip);
}